import request from '@/api/http.js'

export function bdataEdit(data) {
    return request({
        url: 'bdata/edit',
        method: 'post',
        data,
    })
}

export function bdataDelete(data) {
    return request({
        url: 'bdata/delete',
        method: 'post',
        data,
    })
}

export function bdata(data) {
    return request({
        url: 'bdata',
        method: 'get',
        params: data,
    })
}

